<template>
    <div class="box-shadow-inside box-background box-ssjc mt20">
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">最新事件</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <div class="new_list">
            <div class="new_list_item" v-for="(item, idx) in eventList" :key="idx">
                <p class="time">{{item.e__logTime|moment('MM-DD HH:mm')}}</p>
                <p class="text">{{item.e__description||''}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import xhr from "../../../utils/xhr";

let timer=null

export default {
    name: 'MonitorNews',
    data() {
        return {
        }
    },
    computed: {
        eventList() {
            return this.$store.state.monitorData.eventList
        }
    },
    mounted() {
        this.getMonitorEventList()
    },
    methods: {
        getMonitorEventList: function () {
            xhr.getMonitorEventList(20, ({data}) => {
                const eventList = data.data||[]

                this.$store.commit('setMonitorEventData', eventList)

                timer = setTimeout(this.getMonitorEventList, 10000)
            })
        }
    },
    destroyed() {
        timer && clearTimeout(timer)
    }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorNews.vue